<template>
  <div>
    <!-- Dossier controls -->
    <b-row class="d-flex justify-content-between align-items-center bg-light py-3">
      <b-col md="4">
        <b-form-checkbox
          switch
          size="sm"
          >SIOPI</b-form-checkbox
        >
      </b-col>
      <b-col md="4"> <!-- IF SIOPI IS ACTIVE -->
        <b-form-select
          size="sm"
          :options="siopiSituationOptions"
        ></b-form-select>
      </b-col>
      <!--<b-col md="3"> </b-col>-->
      <b-col md="4">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.dossier.dueDate"
          v-if="proposal.steps.dossier.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

var moment = require("moment");
moment.locale("pt-br");

var bootbox = require("bootbox");

export default {
  name: "ControlOfTheSiopiFlow",
  data() {
    return {
      array: "",
      /*showPendingFgtsDialog: false,*/
      siopiSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Em andamento",
          text: "Em andamento",
          color: "secondary",
          msg: "Dossiê em montagem para entrega em",
          progress: 1,
        },
        {
          value: "Pendente de encaminhar",
          text: "Pendente de encaminhar",
          color: "primary",
          msg: "SIOPI concluído pendente de encaminhamento",
          progress: 2,
        },
        {
          value: "Encaminhado",
          text: "Encaminhado",
          color: "success",
          msg: "SIOPI encaminhado para a análise jurídica",
          progress: 3,
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["setModificationNotification"]),
    ...mapActions(["getProposal"]),
  },
  computed: {
    ...mapState(["proposal", "user"]),
  },
  watch: {
    "proposal.steps.dossier.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.dossier.status = "";
      // }
      if (!this.proposal.steps.dossier.dueDate) {
        var today = new Date();
        var dossierDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.dossier.dueDate = dossierDate;
      }
      if (newVal) {
        for (let key in this.dossierSituationOptions) {
          if (newVal === this.dossierSituationOptions[key].value) {
            this.proposal.steps.dossier.color = this.dossierSituationOptions[
              key
            ].color;
            this.proposal.steps.dossier.note = this.dossierSituationOptions[
              key
            ].msg;
            this.proposal.steps.dossier[
              "progress"
            ] = this.dossierSituationOptions[key].progress;
          }
        }
      } else {
        this.proposal.steps.dossier.color = "light";
        this.proposal.steps.dossier.note = "";
        this.proposal.steps.dossier.progress = 0;
      }
    },
    proposal: {
      handler: function (val) {
        if (val.pendingList && val.pendingList.length) {
          this.pendingList = val.pendingList;
        } else if (
          !val.pendingList ||
          (val.pendingList && !val.pendingList.length)
        ) {
          Vue.set(this.proposal, "pendingList", this.pendingList);
        }
        if (val.pendingFgtsList && val.pendingFgtsList.length) {
          this.pendingFgtsList = val.pendingFgtsList;
        } else if (!val.pendingFgtsList) {
          Vue.set(this.proposal, "pendingFgtsList", this.pendingFgtsList);
        }
        if (this.proposal.participants && this.proposal.participants.length) {
          this.proposal.participants.forEach((element) => {
            if (!element.participantList) {
              element.participantList = JSON.parse(
                JSON.stringify(this.participantList)
              );
            }
          });
        }
        if (val.bidderList && val.bidderList.length) {
          this.bidderList = val.bidderList;
        } else if (!val.bidderList) {
          Vue.set(this.proposal, "bidderList", this.bidderList);
        }
      },
      immediate: true,
    },
  },
};
</script>